export default __webpack_public_path__ + "static/media/pictogramBeaconBusinessVehicle128.c8379a07.svg";